import React, { useState, useRef } from "react";
import { API_URL } from "../../../constants/appConfig";
import myToast from "../../../components/toast";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternate as AddPhotoIcon } from "@mui/icons-material";

const CarouselUpdate = ({ category, que, categories }) => {
  const fileInputRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState(category);

  const triggerFileInput = () => fileInputRef.current.click();

  const handleFileUpload = (event) => {
    try {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        const imageData = reader.result;
        const image = new Image();
        image.src = imageData;

        image.onload = () => {
          const width = image.width;
          const height = image.height;
          const aspectRatio = width / height;
          const wantedAspectRatio = 3 / 4;

          if (aspectRatio.toFixed(2) !== wantedAspectRatio.toFixed(2)) {
            myToast({
              status: "error",
              message: "Resim boyutları uygun değil",
            });
            return;
          } else {
            setSelectedCategory({
              ...selectedCategory,
              imageBase64Data: imageData,
            });
          }
        };
      };

      reader.readAsDataURL(file);
    } catch (error) {
      console.error(error);
      myToast({
        status: "error",
        message: "Resim yüklenirken bir hata oluştu",
      });
    }
  };

  const handleSelectCategory = (e) => {
    try {
      const selectedCategory = categories.find(
        (item) => item.categoryId === e.target.value
      );
      setSelectedCategory({
        ...selectedCategory,
        category: {
          categoryId: selectedCategory?.categoryId,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdateCarousel = async () => {
    try {
      const response = await fetch(
        `${API_URL}/homePageCategory/saveHomePageCategory`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedCategory),
        }
      );

      if (response.ok) {
        myToast({
          status: "success",
          message: "İlk kategori başarıyla güncellendi",
        });
      } else {
        myToast({
          status: "error",
          message: "İlk kategori güncellenirken bir hata oluştu",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRadius: 2,
        width: '100%',
        maxWidth: 350,
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)'
        }
      }}
    >
      <Typography variant="h6" color="primary">
        {que + 1}. Kategori
      </Typography>

      <Box sx={{ position: 'relative' }}>
        <input
          accept="image/jpeg, image/png, image/jpg, image/heic"
          type="file"
          ref={fileInputRef}
          onChange={(e) => handleFileUpload(e)}
          hidden
        />
        <Button
          variant="outlined"
          startIcon={<AddPhotoIcon />}
          onClick={triggerFileInput}
          fullWidth
          sx={{ mb: 2 }}
        >
          Görsel Ekle
        </Button>

        {selectedCategory?.imageBase64Data && (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              mb: 2
            }}
          >
            <Box
              component="img"
              src={selectedCategory.imageBase64Data}
              alt="category"
              sx={{
                maxHeight: 240,
                width: 'auto',
                borderRadius: 1,
                aspectRatio: '2/3',
                boxShadow: 2
              }}
            />
          </Box>
        )}
      </Box>

      <TextField
        fullWidth
        label="Kategori Başlığı"
        value={selectedCategory?.homePageCategoryName || ''}
        onChange={(e) =>
          setSelectedCategory({
            ...selectedCategory,
            homePageCategoryName: e.target.value,
          })
        }
        size="small"
      />

      <TextField
        select
        fullWidth
        label="Kategori Seçin"
        value={selectedCategory?.category?.categoryId || ''}
        onChange={handleSelectCategory}
        size="small"
      >
        {categories.map((item) => (
          <MenuItem key={item.categoryId} value={item.categoryId}>
            {item.categoryName}
          </MenuItem>
        ))}
      </TextField>

      <Button
        variant="contained"
        onClick={handleUpdateCarousel}
        sx={{
          mt: 1,
          py: 1,
          textTransform: 'none',
          '&:hover': {
            transform: 'scale(1.02)'
          },
          transition: 'transform 0.2s'
        }}
      >
        Kategoriyi Güncelle
      </Button>
    </Paper>
  );
};

export default CarouselUpdate;
